import React from 'react';
import PropTypes from 'prop-types';
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
} from 'recharts';

import { Spacer } from '@zillow/constellation';

import GraphConstants from 'app/shared/constants/GraphConstants';
import GraphEmptyMessage from 'app/shared/components/Graphs/GraphEmptyMessage';
import GraphTitle from 'app/shared/components/Graphs/GraphTitle';
import SpinnerContainer from 'app/shared/components/SpinnerContainer';

import subMonths from 'date-fns/sub_months';
import format from 'date-fns/format';

const propTypes = {
    data: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
};

const defaultProps = {
    isLoading: false,
};

const GRAPH = GraphConstants.GRAPHS.PROPERTY;
const dataKey = 'Listings';

const ViewGraph = ({ data, isLoading }) => {
    const mappedData = data.map((item, i) => ({
        [dataKey]: item.activeListings,
        name: format(subMonths(new Date(), 11 - i), 'MMM YYYY'),
    }));

    const renderGraph = () => (
        <div>
            {!data.length && <GraphEmptyMessage message="No listings available" />}
            <ResponsiveContainer width="100%" height={300}>
                <BarChart data={mappedData} key={dataKey}>
                    <XAxis dataKey="name" />
                    <YAxis />
                    <CartesianGrid strokeDasharray="3 3" vertical={false} />
                    <Tooltip />
                    <Bar
                        dataKey={dataKey}
                        fill={GraphConstants.COLORS.zillow.primary}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );

    const configs = GRAPH.default;
    return (
        <Spacer marginY="md">
            <GraphTitle
                title={configs.TITLE_PREFIX}
                isLoading={isLoading}
            />
            {isLoading ? <SpinnerContainer /> : renderGraph()}
        </Spacer>
    );
};

ViewGraph.propTypes = propTypes;
ViewGraph.defaultProps = defaultProps;

export default ViewGraph;
